export const getActions = (set) => ({
    setCapsule: capsule => {
        set({ capsule });
    },
});
